import { render, staticRenderFns } from "./NewTraining.vue?vue&type=template&id=1b809696&scoped=true&"
import script from "./NewTraining.vue?vue&type=script&lang=js&"
export * from "./NewTraining.vue?vue&type=script&lang=js&"
import style0 from "./NewTraining.vue?vue&type=style&index=0&id=1b809696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b809696",
  null
  
)

export default component.exports